import { Component, Input } from '@angular/core';
import { Cart } from '@spartacus/cart/base/root';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'app-order-shipping-cost-notice',
    templateUrl: './order-shipping-cost-notice.component.html',
    imports: [TranslatePipe]
})
export class OrderShippingCostNoticeComponent {
  @Input() cart: Cart;
}
